export enum Role {
    Admin = 'admin',
    Teacher = 'Teacher',
    Student = 'Student',
}

export enum ServiceType {
    Group = 'group',
    VIP = 'vip',
}